import * as React from "react";

import { auth } from '../../firebase';
import config from "../../config";
import { trackEvent } from '../analytics/tracking';
import { UserContext } from '../providers/UserProvider';
import SuppressNav from '../layout/SuppressNav';
import AddressSearch from './AddressSearch';
import MediumButton from '../styleguide/MediumButton';

import styles from './FramableLocationSearch.module.css';

/**
 * Home page address entry: Collect address and continue to app home page
 */
const FramableLocationSearch = ({disableDevStyles}) => {
  
  const isDev = window.top === window.self;
  /* redirect=true to suppress over 21 modal on app.ziprun.com */ 
  const navigationHost = isDev 
              ? `${window.location.protocol}//${window.location.host}`
              : 'https://app.ziprun.com?redirect=true';
    
  // The provider will store/persist the provided address, but not in Safari...
  const { setSearchLocation } = React.useContext(UserContext);            
  // So the address hash is better
  const [ addressHash, setAddressHash] = React.useState('');

  // Style for non-iframe dev purposes
  if (isDev && !disableDevStyles) {
    document.body.classList.add('testMode'); 
  }  

  const navigateToApp = () => {
    window.top.location.href = `${navigationHost}${addressHash}`;
  };

  const navigateToAppSignIn = () => {
    window.top.location.href = `${navigationHost}#showLogin.true`;
  };

  /* Record component render so we can calc the authed percentage of home page visitors */
  React.useEffect(() => {
    trackEvent('homepage_iframe_render');
  }, []);

  /* Skip address input for registered users */
  const [isRegistered, setIsRegistered] = React.useState();

  React.useEffect(() => {
    /* eslint-disable no-unused-vars */
    let stateChangeHandler = auth.onAuthStateChanged(() => {
      if (auth && 
          auth.currentUser && 
          !auth.currentUser.isAnonymous) {
        setIsRegistered(true);
        /* track authed percentage of home page visitors */
        trackEvent('homepage_iframe_authed_user');
      }
    });
    return () => { stateChangeHandler = undefined };  
  }, []);

  return (
    <div className={styles.framedContentWrap}>
      <SuppressNav /> 
      { config.IS_DISABLED
        ? <div className={styles.shoppingPausedMsg}>
            <div className={styles.hdrLarge}>
              Cannabis products delivered in a <i>ZIP!</i>
            </div>
          </div>
        : isRegistered  
          ? <div className={styles.registeredUserMsg}>
              <div className={styles.hdrLarge}>Welcome back, we're open for pickup orders!*</div>
              <div className={styles.btnWrap}>
                <MediumButton text="Shop Cannabis Products" handleClick={navigateToApp} />
              </div>
              <div className={styles.minorDetail} style={{fontStyle:'italic'}}>
                *Currently serving Greater Boston 
              </div>
            </div>
          : <>
              <div className={styles.hdrLarge}>
                Boston, order cannabis pickup&nbsp;&amp; delivery.
              </div>
              <div className={styles.inputWrap}>
                <AddressSearch
                  onComplete={navigateToApp}
                  handleUpdate={(address) => {
                    setSearchLocation(address);
                    setAddressHash(`#address.${window.btoa(JSON.stringify(address))}`);
                  }}
                  isWideDesign />
                <div className={styles.minorDetail}>
                  Already have an account?{' '}
                  <span className={styles.appLink} onClick={navigateToAppSignIn}>
                    Sign In
                  </span>
                </div>
              </div>
            </>
      }
    </div>
  );
}

export default FramableLocationSearch;